import { createAgnosticHttpClient } from 'auth/infra/createAgnosticHttpClient'

import {
  type UpdateShipmentTractorNumberParams,
  ShipmentRepository,
} from '../infra/ShipmentRepository'

export type UpdateShipmentTractorNumberFactoryDependencies = {
  repository: ShipmentRepository
}

export function updateShipmentTractorNumberFactory({
  repository,
}: UpdateShipmentTractorNumberFactoryDependencies) {
  return async function updateShipmentTractorNumber({
    shipmentUUID,
    tractorNumber,
    config,
  }: UpdateShipmentTractorNumberParams) {
    try {
      return await repository.updateShipmentTractorNumber({ shipmentUUID, tractorNumber, config })
    } catch (error) {
      throw new Error('Failed to add tractor to the shipment', { cause: error as Error })
    }
  }
}

export function updateShipmentTractorNumber({
  shipmentUUID,
  tractorNumber,
  config,
}: UpdateShipmentTractorNumberParams) {
  const httpClient = createAgnosticHttpClient()
  const repository = new ShipmentRepository({ httpClient })
  const updateTractor = updateShipmentTractorNumberFactory({ repository })

  return updateTractor({ shipmentUUID, tractorNumber, config })
}
